import {createHashRouter, RouterProvider} from "react-router-dom";
import KeepAlive from 'react-activation'
import "nprogress/nprogress.css";
import './App.scss'
import './assets/styles/main.css'
import './assets/styles/app.css'
import React, {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import Home from '@/pages/Home'
import {getCategory, registerUser, getUserInfo, changeMenuState,saveConfig,setHeader,setQuestions} from "@/store/actions/app";
import {getToken} from "@/utils/storage";

import Tab from '@/pages/Tab'
import Video from '@/pages/Video'
import Account from '@/pages/Account'
import Recharge from '@/pages/Recharge'
import Phone from '@/pages/Phone'
import Search from '@/pages/Search'
import Column from '@/pages/Column'
import Collect from '@/pages/Collect'
import Purchased from '@/pages/Purchased'
import Backurl from '@/pages/Backurl'
import Message from '@/pages/Message'
import Nave from '@/pages/Nave'
import emitter from '@/utils/events'
import {AliveScope} from 'react-activation'
import AnnouncementReadyContext from '@/components/AnnouncementModal/readiness'

function isObjectEmpty(obj: object): boolean {
    return Object.keys(obj).length === 0;
}

const router = createHashRouter([
    {
        path: "/",
        element:(<KeepAlive id="/home">
            <Home></Home>
        </KeepAlive>),
    },
    {
        path: "/home",
        element:(<KeepAlive id="/home">
            <Home></Home>
        </KeepAlive>),
    },
    {
        path: "/nave",
        element:(<Nave />),
    },
    {
        path: "/tab/:id",
        element:(<KeepAlive id="/tab">
            <Tab />
        </KeepAlive>),
    },
    {
        path: "/category/:id/:cid/:name/:cname",
        element:(<KeepAlive id="/category">
            <Tab />
        </KeepAlive>),
    },
    {
        path: "/column/:id/:name",
        element:(<KeepAlive id="/column">
            <Column />
        </KeepAlive>),
    },
    {
        path: "/video/:id",
        element: <Video />,
    },
    {
        path: "/search/:key",
        element: (<KeepAlive id="/search">
            <Search />
        </KeepAlive>),
    },
    {
        path: "/account",
        element: <Account />,
    },
    {
        path: "/recharge",
        element: <Recharge />,
    },
    {
        path: "/phone",
        element: <Phone />,
    },
    {
        path: "/backurl",
        element: <Backurl />,
    },
    {
        path: "/collect",
        element: <Collect />,
    },
    {
        path: "/purchased",
        element: <Purchased />,
    },
    {
        path: "/message",
        element: <Message />,
    },
]);

function App() {
    const dispatch = useDispatch()
    const [announcementReady, setAnnouncementReady] = useState(false)
    useEffect(() => {
        let mounted = true
        const token = getToken()
        const handleReload = () => {
            dispatch(getUserInfo())
        }

        dispatch(getCategory())
        dispatch(setHeader())
        dispatch(setQuestions())
        emitter.addListener("reload",handleReload);

        const configRequest = dispatch(saveConfig()) as unknown as Promise<void>
        const userRequest = (!token || isObjectEmpty(token))
            ? dispatch(registerUser()) as unknown as Promise<void>
            : dispatch(getUserInfo()) as unknown as Promise<void>

        Promise.all([configRequest, userRequest]).then(() => {
            if (mounted) {
                setAnnouncementReady(true)
            }
        })

        dispatch(changeMenuState(false))
        return () => {
            mounted = false
            emitter.removeListener("reload", handleReload);
        };

    }, [dispatch])
    return (
        <AnnouncementReadyContext.Provider value={announcementReady}>
            <AliveScope>
                <RouterProvider router={router}/>
            </AliveScope>
        </AnnouncementReadyContext.Provider>
    );
}

export default App
